// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityResultBase {
    static getAttributeTypeMap() {
        return MedicalEligibilityResultBase.attributeTypeMap;
    }
}
MedicalEligibilityResultBase.discriminator = undefined;
MedicalEligibilityResultBase.additionalProperties = false;
MedicalEligibilityResultBase.attributeTypeMap = [
    {
        "name": "annual",
        "baseName": "annual",
        "type": "MedicalEligibilityAnnual"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "MedicalEligibilityCopay"
    },
    {
        "name": "family",
        "baseName": "family",
        "type": "MedicalEligibilityFamily"
    },
    {
        "name": "individual",
        "baseName": "individual",
        "type": "MedicalEligibilityIndividual"
    },
    {
        "name": "lifetime",
        "baseName": "lifetime",
        "type": "MedicalEligibilityLifetime"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalEligibilityPatientResult"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalEligibilityPayorResult"
    },
    {
        "name": "pbm",
        "baseName": "pbm",
        "type": "MedicalEligibilityPbm"
    },
    {
        "name": "preferredSpecialty",
        "baseName": "preferredSpecialty",
        "type": "MedicalEligibilityPreferredSpecialty"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalEligibilityPrescriberResult"
    },
    {
        "name": "specialtyPharmacy",
        "baseName": "specialtyPharmacy",
        "type": "MedicalEligibilitySpecialtyPharmacy"
    },
    {
        "name": "spendDown",
        "baseName": "spendDown",
        "type": "MedicalEligibilitySpendDown"
    },
    {
        "name": "taskStatus",
        "baseName": "taskStatus",
        "type": "string"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalEligibilityResultBase.js.map